import React, { FC, useState, CSSProperties, useCallback } from "react";

import throttle from "lodash-es/throttle";

import TextEditor from "./TextEditor";
import { EditorProps } from "./Editor";
import { Tooltip } from "@axin-org/comet";

export const STYLES: CSSProperties = {
  width: "100%",
  height: "calc(100% - 5px)",
  overflowY: "hidden"
};

export const STYLES_FOCUSED: CSSProperties = {
  width: "100%",
  minHeight: "10rem",
  zIndex: 50,
  overflowY: "auto"
};

export const DatatableEditor: FC<EditorProps> = props => {
  const [isFocused, setIsFocused] = useState(false);

  const onValueChangeThrolled = useCallback(
    throttle((text: string, name: string | undefined) => {
      props.onValueChange && props.onValueChange(name, text);
    }, 100),
    []
  );

  return (
    <Tooltip label={<div dangerouslySetInnerHTML={{ __html: props.value }} />}>
      <div>
        <TextEditor
          {...props}
          toolbar="HOVER"
          onValueChange={onValueChangeThrolled}
          onFocus={() => setIsFocused(true)}
          onBlur={e => {
            if (props.onBlur) {
              props.onBlur(e);
            }
            setIsFocused(false);
          }}
          style={isFocused ? STYLES_FOCUSED : STYLES}
        />
      </div>
    </Tooltip>
  );
};
